import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { FormGroup, FormGroupProps, FormGroupType } from "./formGroup";

interface FormColorProps extends Controls.ControlColorProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    groupType?: FormGroupType | undefined;
}

const ComponentProps = (props: FormColorProps): Controls.ControlColorProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormColorProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormColor: React.FC<Controls.ControlColorProps> = (props) => {
    const styles: IFormStyles = useFormStyles();
    
    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlColor {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};